class scrollWatch {
    constructor($rootScope,$ionicScrollDelegate) {
        this.restrict = 'A';
        this.link = (scope, element, attrs) => {

            let threshold = 180;
            let initialValue = 0;
            $rootScope.hideBar = false;

            if($rootScope.isMobileView){
                element.bind('scroll', function(e) {

                    let currentPosition = $ionicScrollDelegate.$getByHandle('mainScroll').getScrollPosition().top;
                    if (currentPosition <= threshold) {
                      $rootScope.hideBar = false;
                    } else {
                      if(initialValue < currentPosition){
                          $rootScope.hideBar = true;
                      } else if (initialValue - currentPosition > 3) {
                          $rootScope.hideBar = false;
                      }
                    }
                    $rootScope.$apply();
                    initialValue = currentPosition;
                });
            }
        }
    }

    /**
     * Factory
     * @return {Object}
     */
    static directiveFactory($rootScope, $ionicScrollDelegate) {
        scrollWatch.instance = new scrollWatch($rootScope, $ionicScrollDelegate);
        return scrollWatch.instance;
    }
}

export default scrollWatch;



/** WEBPACK FOOTER **
 ** ./src/app/directives/scrollWatch/scrollWatch.js
 **/